module.exports = __webpack_public_path__ + "img/sample-dataScientist.e5f98a65.webp";